// Full-screen stop for a creator whose account an admin has banned. The
// backend refuses every creator API call from a banned account except
// GET /api/creators/me (app/services/account_gate.py), so there is nothing
// else this person can usefully see — ProtectedRoute renders this in place of
// every creator page.
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Ban } from 'lucide-react';
import { signOutUser } from '../../features/auth/authSlice';

export const ACCOUNT_BLOCKED_EVENT = 'mintlink:account-blocked';

const AccountBanned = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await dispatch(signOutUser());
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Ban className="w-10 h-10 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Account banned</h2>
        <p className="text-gray-600 mb-6">
          Your MintLink account has been permanently banned following a review by our
          Trust &amp; Safety team. You can no longer list products, add payout details or
          make changes to this account.
        </p>
        <div className="bg-red-50 rounded-lg p-4 text-sm text-red-900 text-left mb-6">
          <p className="font-semibold mb-1">Think this is a mistake?</p>
          <p>
            Email{' '}
            <a href="mailto:info@mintlink.in?subject=Account%20Termination%20Appeal" className="underline">
              info@mintlink.in
            </a>{' '}
            with the subject “Account Termination Appeal” within 10 business days of your ban notice.
          </p>
        </div>
        <button
          type="button"
          onClick={handleSignOut}
          className="w-full rounded-lg bg-gray-900 px-4 py-2.5 text-white font-medium hover:bg-gray-800"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default AccountBanned;
